<!--
  과정 큐래이션 목록(Tab list) 컴포넌트
-->
<template>
  <section
    v-if="potltData.crtnTyp === 'TAB'"
    :style="`padding: ${potltData.btomGapNum}px 0; background-color: ${potltData.potltBgColorCd}`"
    class="section_home curation"
    data-effect-slide="scroll"
  >
    <div class="inner">
      <div
        v-if="curationData !== null"
        :id="idPrefix + cuId"
        class="mmp_curation tab_list"
      >
        <!-- curation header -->
        <div
          :class="{'has_icon': showTitleIcon && (curationTabData.icon !== '' || curationTabData.icon !== null)}"
          class="curation_header"
        >

          <!-- title -->
          <h2>
            <span
              v-if="showTitleIcon && (curationTabData.icon !== '' || curationTabData.icon !== null)"
              class="icon"
            >
              <img :src="curationTabData.icon">
            </span>
            <span class="txt">{{ potltInfo.potltNm }}</span>
          </h2>
          <!-- // title -->

        </div>
        <!-- // curation header -->

        <!-- 탭 리스트 -->
        <div ref="tabListSwiper" class="wrap_tab_list swiper-container">
          <div class="inner swiper-wrapper">
            <div
              v-for="(item, index) in tabList"
              :key="index"
              class="tab_item swiper-slide"
            >
              <button
                :data-tab-id="item.crtnSysopTabSno"
                :class="['btn_tab', {'active' : index === 0}]"
                type="button"
                @click="clickTab($event, item)"
              >{{ item.tabNm }}</button>
            </div>
          </div>
        </div>
        <!-- // 탭 리스트 -->

        <!-- 탭 콘텐츠 -->
        <div class="wrap_tab_content curation_content">
          <ul v-if="isVisable" class="wrap_curation">
            <li
              v-for="(courseItem, courseIndex) in visibleItems"
              :key="courseIndex"
              class="st_item"
            >
              <div class="st_link" style="cursor:pointer" @click="openDetail(courseItem)">
                <!-- 과정목록 아이템 컴포넌트 -->
                <CompCourseItem
                  :show-footer="false"
                  :course-item="courseItem"
                />
                <!-- // 과정목록 아이템 컴포넌트 -->
              </div>
            </li>
          </ul>
          <ul v-else class="wrap_curation">
            <li>
              데이터가 없습니다.
            </li>
          </ul>

          <!-- 더보기 버튼 -->
          <div v-if="isVisable" class="wrap_more_btn">
            <button
              v-if="showMoreButton"
              type="button"
              class="btn_more"
              @click="loadMoreContent"
            >{{ moreBtnText }} 강의 더보기</button>
          </div>
          <!-- // 더보기 버튼 -->
        </div>
        <!-- // 탭 콘텐츠 -->
      </div>
    </div>
  </section>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {isEmpty} from 'lodash'
import MotionEffects from '/src/assets/js/MotionEffects'
import CompCourseItem from '~pages/nrw/portlet/CompCourseItem'

export default {
  name: 'UserCurationTabList',
  components: {
    Swiper,
    SwiperSlide,
    CompCourseItem
  },
  mixins: [MotionEffects],
  props: {
    potltInfo: {
      type: Object,
      default: null
    },
    // 화면에 노출할 슬라이드 갯수 (PC)
    slidesPerViewPc: {
      type: Number,
      default: 3
    },
    // 화면에 노출할 슬라이드 갯수 (MO)
    slidesPerViewMo: {
      type: Number,
      default: 1
    },
    // 큐레이션유형
    crtnTyp: {
      type: String,
      default: null
    },
    // 큐레이션 고유번호
    cuId: {
      type: String,
      default: null
    },
    // 큐레이션 타이틀 영역에 아이콘 표시 여부
    showTitleIcon: {
      type: Boolean,
      default: false
    },
    // 태그 UI 노출 여부
    showTag: {
      type: Boolean,
      default: true
    },
    // 별점, 댓글 UI 노출 여부
    showReview: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      curationData: null, // 큐레이션 데이터
      idPrefix: 'curation_', // wrapper ID 앞에 추가되는 고정 값 (id="curation_'큐레이션고유번호''")
      potltData: {}, // 포틀릿 기본 데이터
      swiperInstance: null,
      // 스와이퍼 옵션
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true
      },
      tabList: [], // 탭 목록
      tabData: {}, // 탭 데이터를 저장하는 객체
      visibleCount: 0, // 초기 보여지는 항목 수
      moreBtnText: null, // 강의 더보기 앞에 위치하는 텍스트
      isVisable: true
    }
  },
  computed: {
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    isMobile () {
      return !window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    showMoreButton () {
      return this.visibleCount < this.curationData.length
    },
    visibleItems () {
      return this.curationData.slice(0, this.visibleCount)
    }
  },
  created () {
    if (isEmpty(this.potltInfo)) return

    const { potltData, tabList } = this.potltInfo
    this.potltData = potltData[0]
    this.crtnTyp = this.potltData.crtnTyp
    this.tabList = tabList
    this.moreBtnText = tabList[0].tabNm

    // 모든 큐레이션 데이터를 미리 불러오기
    if (this.crtnTyp === 'TAB' && !isEmpty(this.tabList)) {
      this.tabList.forEach(tab => {
        const params = { ctrnNo: this.potltData.crtnNo, crtnSysopTabSno: tab.crtnSysopTabSno, mbrNo: this.getMbrNo(), langCd: this.getUserLangCd() }

        this.fetchData('selectUserCurationTabCorsList', params, (data) => {
          // ;와 #를 ,로 치환
          if (data && Array.isArray(data)) {
            data.forEach(obj => {
              if (obj && obj.srchKwrdCntnt !== null) {
                obj.srchKwrdCntnt = obj.srchKwrdCntnt.replace(/;|#/g, ',')
              }
            })
          }

          this.tabData[tab.crtnSysopTabSno] = data

          // 초기 큐레이션 데이터 설정 (첫 번째 탭 데이터로 설정)
          if (tab === this.tabList[0]) {
            this.fetchTabData(tab)
          }
        })
      })
    }
  },
  mounted () {
    // 초기 보여지는 항목 수 설정(pc와 mobile 같게 설정)
    this.visibleCount = this.isDesktop ? this.slidesPerViewPc : this.slidesPerViewPc
  },
  beforeDestroy () {
    this.destroySwiper()
  },
  methods: {
    // 탭 리스트 스와이퍼 UI 설정
    initSwiper () {
      const _this = this
      setTimeout(function () {
        const swiperContainer = _this.$refs.tabListSwiper
        _this.swiperInstance = new Swiper(swiperContainer, _this.swiperOption)
      }, 400)
    },

    // 스와이퍼 UI 해제
    destroySwiper () {
      // swiperInstance가 null이 아니고 destroy 메서드가 존재하면 실행
      if (this.swiperInstance && typeof this.swiperInstance.destroy === 'function') {
        this.swiperInstance.destroy(true, true)
        this.swiperInstance = null
      }
    },
    // 탭 버튼 클릭 이벤트 (활성 탭 변경)
    clickTab (event, item) {
      const tab = event.target
      const tabs = document.querySelectorAll(`#${this.idPrefix + this.cuId} .btn_tab`)

      // 탭 활성화 스타일 제거
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('active')
      }

      // 선택한 탭의 스타일 정리
      if (tab && !tab.classList.contains('active')) {
        tab.classList.add('active')
      }

      // 초기 보여지는 항목 수 설정(pc와 mobile 같게 설정)
      this.visibleCount = this.isDesktop ? this.slidesPerViewPc : this.slidesPerViewPc

      this.moreBtnText = item.tabNm

      // 큐레이션 데이터 설정
      this.fetchTabData(item)
    },
    // 큐레이션 데이터 설정
    fetchTabData (item) {
      const result = this.tabData[item.crtnSysopTabSno]

      if (result !== null) {
        this.isVisable = true

        this.curationData = result.map(course => ({
          ...this.potltData,
          title: course.prdtNm,
          thumbPc: course.thumbLinkUrl,
          thumbMo: course.thumbLinkUrl,
          link: course.corsCd,
          label: [
            ...(course.prdtAttrTypNm ? [course.prdtAttrTypNm === '일반이러닝' ? '이러닝' : course.prdtAttrTypNm === '실시간' ? '비대면' : course.prdtAttrTypNm] : []), // 대면,비대면,이러닝
            ...(course.diflvTypNm ? [course.diflvTypNm] : []), // 초급,중급,고급
            ...(course.txtbkNm ? [course.txtbkNm] : []) // 교재제공
          ],
          tag: course.srchKwrdCntnt ? course.srchKwrdCntnt.split(',').map(date => date.trim()) : [],
          schedule: course.eduDtm ? course.eduDtm.split(',').map(date => date.trim()) : [],
          rating: course.evalAvg ? course.evalAvg.toString() : '0',
          review: course.evalCnt ? course.evalCnt.toString() : '0'
        }))
      } else {
        console.log('데이터 없음')
        this.isVisable = false
      }

      // 탭 리스트 스와이퍼 UI 설정
      this.initSwiper()
    },
    // 더보기 버튼 클릭 (콘텐츠 더보기)
    loadMoreContent () {
      // pc와 mobile 같게 설정
      this.visibleCount += this.isDesktop ? this.slidesPerViewPc : this.slidesPerViewPc
    },
    // 과정 상세로 이동
    openDetail (courseItem) {
      this.$goPage({name: 'CrsDetail', query: { corsCd: courseItem.link }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/UserCurationTabList.vue